import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.invoice-request',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.invoice-request/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.invoice-request/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.invoice-request/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice-request/${id}`,
    method: 'put',
    data,
  })
}

export const exportDocx = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice-request/${id}/export`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.invoice-request/${id}/apply`,
    method: 'put',
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice-request/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice-request/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number) => {
  return axiosService({
    url: `/api.invoice-request/${id}/approve`,
    method: 'put',
    data: {},
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.invoice-request/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.invoice-request',
    method: 'post',
    data,
  })
}
